import { PaginationProps } from '@/trio-ui/Pagination/Pagination.component';
import { LocalStorageItemKeys } from '@/types';

type PaginationData = Omit<PaginationProps, 'onChangeRecordsPerPage' | 'onChangePageHandler'>;

export const setPaginationDataToLocalStorage = (newPaginationData: PaginationData): void => {
  window.localStorage.setItem(
    LocalStorageItemKeys.CANDIDATE_TABLE_PAGINATION,
    JSON.stringify(newPaginationData)
  );
};

export const getPaginationDataFromLocalStorage = (): PaginationData | null => {
  const paginationData = window.localStorage.getItem(
    LocalStorageItemKeys.CANDIDATE_TABLE_PAGINATION
  );

  if (paginationData) {
    const parsedPaginationData = JSON.parse(paginationData);
    return parsedPaginationData;
  }

  return null;
};
